import React, {useState, useEffect} from "react";
import Cookies from 'universal-cookie';
import "./gdpr.scss";
import "./modal.scss";
import {graphql, useStaticQuery} from "gatsby";
import { Button } from '../../elements/Button/button';
import {Title} from "../../elements/Title/title";
import {Text} from "../../elements/Text/text";

function Gdpr() {
    const myQuery = useStaticQuery(query);
    const country = myQuery.site.siteMetadata.config.country;
    const static_text = require("../../../content/" + country + "/static-text.json");
    const [needShowGdpr, setNeedShowGdpr] = useState("none");
    const [showModal, setShowModal] = useState(false);
    const [userValue, setUserValue] = useState(true);

    const handleSave = e => {
        setShowModal(false);
        setNeedShowGdpr("none");
        document.body.style.overflow = 'unset';

        let headID = document.getElementsByTagName('head')[0];
        let gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.type = 'text/javascript';

        let cookies = new Cookies();
        cookies.set('cookie_notice', "1", { path: '/' });

        if (cookies.get('cookie_adsense') === "0") {
            gaScript.src = '/adsense-nonpersonalized-continue.js';
        } else {
            gaScript.src = '/adsense-personalized-continue.js';
        }
        headID.appendChild(gaScript);
    }

    const handleSaveAndClose = e => {
        document.body.style.overflow = 'unset';
        setShowModal(false);
        setNeedShowGdpr("none");
        let cookies = new Cookies();
        cookies.set('cookie_notice', "1", { path: '/' });

        let headID = document.getElementsByTagName('head')[0];
        let gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = '/adsense-personalized-continue.js';
        gaScript.type = 'text/javascript';
        headID.appendChild(gaScript);
    }

    const handleChange = e => {
        let cookies = new Cookies();
        cookies.set('cookie_adsense', e.target.checked ? '1' : "0", { path: '/' });
    }

    useEffect(() => {
        let cookies = new Cookies();
        if (cookies.get('cookie_notice') !== "1") {
            // cookies.set('cookie_notice', '0', { path: '/' });
            setNeedShowGdpr("block")
            document.body.style.overflow = 'hidden';

            const headID = document.getElementsByTagName('head')[0];
            const gaScript = document.createElement('script');
            gaScript.async = true;
            gaScript.src = '/adsense-pause.js';
            gaScript.type = 'text/javascript';
            headID.appendChild(gaScript);
        }
    }, []);

    let cookies = new Cookies();
    if (cookies.get('cookie_adsense') === "0") {
        setUserValue(false);
    }

    return (
          <>
              <div className="m-modal" style={{display: needShowGdpr}}>

                  {showModal ?
                      <div className="m-modal--content">
                          <header><Title size20 content={static_text.cookie_modal_title}
                                         className="text-align--center marg-b16"/></header>
                          <body>
                              <div className="m-modal--checkbox">
                                  <label className="checkbox-green">
                                      <input type="checkbox" checked disabled/>
                                      <span className="checkbox-green-switch" data-label-on="On" data-label-off="Off"></span>
                                  </label>
                                  <Text size15 content={static_text.cookie_modal_tech}/>
                              </div>
                              <div className="m-modal--checkbox">
                                  <label className="checkbox-green">
                                      <input type="checkbox" checked={userValue} onChange={e => handleChange(e)}/>
                                      <span className="checkbox-green-switch" data-label-on="On" data-label-off="Off"></span>
                                  </label>
                                  <div className="d-inline-block">
                                      <Text size15 content={static_text.cookie_modal_adv}/>
                                      <Text size13 content={static_text.cookie_modal_adv_sub}/>
                                  </div>
                              </div>
                          </body>
                          <footer>
                              <Button monster
                                      primary
                                      content={static_text.cookie_modal_save}
                                      onClickFunction={() => handleSave()}
                              />
                          </footer>
                      </div>

                      :

                      <div className={"m-modal--content"}>

                          <header>
                              <Title size20 content={static_text.cookie_acept_title}
                                     className="text-align--center marg-b16"/>
                          </header>

                          <body>
                            {static_text.gdpr} <a href={static_text.cookie_google_policy_url} target="_blank">{static_text.cookie_google_policy_title}</a> <a href="/privacy-policy">{static_text.cookie_more_info}</a>
                          </body>

                          <footer>
                              <Button monster
                                      primary
                                      content={static_text.cookie_accept_button}
                                      onClickFunction={() => handleSaveAndClose()}
                              />

                              <div className={"custom-action"} onClick={() => setShowModal(true)}>
                                  {static_text.cookie_personal}
                              </div>
                          </footer>
                      </div>
                  }
              </div>
          </>
    );
};

export default Gdpr;

const query = graphql`
  query {
    site {
      siteMetadata {
        config {
          country
        }
      }
    }
  }
`;